import { useEffect, useState } from 'react';
import { Alert, Text } from '@nimbus-ds/components';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import useOnboardingTasks from 'domains/Dashboard/pages/DashboardPage/components/OnboardingTasks/useOnboardingTasks';

function OnboardingCompletedAlert() {
  const t = useTranslationDashboard();
  const { isPos, isChat, isPoschat } = useOnboardingTasks();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const alertShown = localStorage.getItem('onboarding-202411-completed');
    if (!alertShown) {
      setShow(true);
    }
  }, []);

  const handleRemove = () => {
    localStorage.setItem('onboarding-202411-completed', 'true');
    setShow(false);
  };

  const getAlertProps = () => {
    const getPrefix = () => {
      if (isChat) return 'chat';
      if (isPoschat) return 'poschat';
      if (isPos) return 'pos';
      return null;
    };

    const prefix = getPrefix();

    if (prefix) {
      return {
        title: `${prefix}OnboardingCompleteAlert.title`,
        description: `${prefix}OnboardingCompleteAlert.description`,
      };
    }

    return {
      title: 'promoteOnboardingCompleteAlert.title',
      description: 'promoteOnboardingCompleteAlert.description',
    };
  };

  const { title, description } = getAlertProps();

  return (
    <Alert
      appearance="success"
      show={show}
      title={t(`${title}`)}
      onRemove={handleRemove}
    >
      <Text>{t(`${description}`)}</Text>
    </Alert>
  );
}

export default OnboardingCompletedAlert;
